import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DropdownSvg from "@svg/chevron-thin.svg"
interface Props {
    value: string | number
    options: {
      name: string | number
      value: string | number
    }[]
    onChange: any
  }

const DropdownSort = ({value, options, onChange}: Props) => {
    const [showOptions, setShowOptions] = useState(false);

    const closeMenu = () => {
        if(showOptions)
            setShowOptions(false);
    }

    useEffect(() => {
        window.addEventListener('click', closeMenu);
        return () => window.removeEventListener('click', closeMenu);
    }, [showOptions])

    return (
        <Label>
          Sort By
        <SelectWrapper>
        <StyledSelect
            onChange={e => onChange(e)}
            onClick={() => setShowOptions(!showOptions)}
        >   
        <SelectText>
        {value}
        </SelectText>
        <DropdownIcon/>
        </StyledSelect>
        <OptionsContainer>
        {showOptions && options.map(({ name, value }) => (
            <Option key={value} onClick={() => {onChange({target: {value}}); setShowOptions(false)}}>
                {name}
            </Option>
            ))}
            </OptionsContainer>
        </SelectWrapper>
        </Label>
    );
};

const Label = styled.label`
  font-size: 1.2rem;
  line-height: 2.8rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.grey};
`

const SelectWrapper = styled.div`
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  letter-spacing: 0.02rem;
`

const StyledSelect = styled.div`
  color: black;
  text-transform: capitalize;
  position: relative;
  box-sizing: border-box;
  -webkit-appearance: none;
  width: 100px;
  margin-left: 5px;
  padding: 1.1rem 4rem 1.1rem 1.3rem;
  background: ${({ theme }) => theme.color.white};
  font-size: 1.4rem;
  font-family: ${({ theme }) => theme.font.primary};
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 1.4rem 1.2rem;
  border: 1px solid #d8d8d8;
  border-radius: 3px;
  background: #FFF;
  font-size: 1.5rem;
  line-height: 1.4rem;
`

const SelectText = styled.div`
    flex: 4;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    user-select: none;
`

const OptionsContainer = styled.div`
    position: absolute;
    background-color: white;
    right: 0px;
    z-index: 100000;
    border-radius: 3px;
    border-right: 1px solid ${({ theme }) => theme.color.greyLight};
    border-top: 1px solid ${({ theme }) => theme.color.greyLight};
    border-left: 1px solid ${({ theme }) => theme.color.greyLight};
`

const Option = styled.div`
    color: black;
    text-transform: capitalize;
    font-size: 1.4rem;
    padding: 7px 0 7px 15px;
    width: 200px;
    border-bottom: 1px solid #EDEDED;
    :hover{
        background-color: #F4F4F4;
        cursor: pointer;
    }
`

const DropdownIcon = styled(DropdownSvg)`
  pointer-events: none;
  width: 1rem;
  path {
    opacity: 1;
  }
`

export default DropdownSort;